import contractTerminationSubmitErrorAlertDictionary from '@widgets/contract-termination-submit-error-alert/i18n/ru/contract-termination-submit-error-alert.dic.json';

export const contractTerminationSubmitErrorAlert = {
  CONTRACT_TERMINATION_SUBMIT_ERROR_ALERT:
    contractTerminationSubmitErrorAlertDictionary,
};

export const contractTerminationSubmitErrorAlertNamespaces = [
  'CONTRACT_TERMINATION_SUBMIT_ERROR_ALERT',
];
